import { Component } from '@angular/core';
import { news } from '../../data/newsData'

@Component({
  selector: 'default-news',
  templateUrl: './news.component.html',
  styleUrls: []
})
export class NewsComponent {
  news = news;
}
